var map = {
	"./BedFileDropdown.demo.js": 47933,
	"./ColorPicker.demo.js": 38970,
	"./HelpButton.demo.js": 30002,
	"./RegionInput.demo.js": 56237,
	"./TrackDeleteButton.demo.js": 47246,
	"./TrackFilePicker.demo.js": 76391,
	"./TrackList.demo.js": 41768,
	"./TrackListItem.demo.js": 27908,
	"./TrackPicker.demo.js": 80142,
	"./TrackPickerDisplay.demo.js": 7961,
	"./TrackSettings.demo.js": 82022,
	"./TrackSettingsButton.demo.js": 15488,
	"./TrackTypeDropdown.demo.js": 3815
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 19738;